module.exports = __webpack_public_path__ + "assets/img/1021.15c89204.png";